module.exports = __webpack_public_path__ + "media/images/clearco-airwallex-b0b1042b5d11a7ec616fba5fb2217e6a.png";